import { CSSVariablesResolver } from "@mantine/core"

export const CSSresolver: CSSVariablesResolver = (theme) => {
  return {
    variables: {
      "--mantine-brand-header-height": "4rem",
      "--mantine-supplier-header-height": "4rem",
      "--tfg-layout-padding-x": theme.spacing.xl,
      "--tfg-layout-padding-y": theme.spacing.lg,
      "--tfg-card-border-radius": theme.radius.md,
      "--tfg-organism-padding-x": theme.spacing.md,
      "--tfg-organism-padding-y": theme.spacing.sm,
      "--tfg-molecule-padding-x": theme.spacing.sm,
      "--tfg-molecule-padding-y": theme.spacing.xs,
    },
    light: {
      "--mantine-color-text": theme.colors.gray[8],
      "--mantine-color-dimmed": theme.colors.gray[5],
      "--mantine-color-supplier-header-text": theme.colors.gray[8],
      "--mantine-color-supplier-background": theme.colors.gray[1],
      "--mantine-color-supplier-header-bg": "var(--mantine-color-white)",
      "--mantine-color-brand-header-bg": theme.colors.gray[8],
      "--mantine-color-brand-header-text": "var(--mantine-color-white)",
      "--mantine-color-brand-background": theme.colors.gray[0],
      "--mantine-color-error": theme.colors.red[6],
    },
    dark: {},
  }
}
